<div id="course-lock" *ngIf="!locked">

    <h1 class="mb-3">Terminar edición y solicitar instalación</h1>

    <p>Estás a punto de terminar la edición de este curso y notificar su instalación en la plataforma FORTEC.</p>
    <p>Al terminar la edición de un curso, éste se bloquea, y ya no se pueden hacer cambios.</p>
    <p>También se notificará a los técnicos para que procedan a su instalación en la plataforma FORTEC.</p>
    <p>Recuerda que la instalación del curso puede durar hasta 5 días hábiles, así que avisa con tiempo.</p>
    <p *ngIf="!finalWarning">¿Estás segur&#64; de que desea continuar?</p>

    <div id="final-warning" class="fw-bold" *ngIf="finalWarning">
        <p>¿Estás absolutamente segur&#64; de que desea terminar la edición del curso y solicitar su instalación?</p>
    </div>

    <div id="status" class="mb-3">
        <div id="course-locking" *ngIf="locking">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="course-lock-success" class="text-success" *ngIf="lockSuccess">
            <i class="fas fa-check"></i>
            <span>Terminado. Ahora se recargará la página.</span>
        </div>
        <div id="course-lock-error" class="text-danger" *ngIf="lockError">
            <i class="fas fa-times"></i>
            <span>Error</span>
        </div>
    </div>

    <div id="buttons">
        <button class="btn btn-success me-3" (click)="lock()">
            <i class="fa fa-lock"></i>
            <span>Continuar</span>
        </button>
        <button class="btn btn-danger me-3" (click)="close()">
            <i class="class fa fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

</div>

<div id="course-unlock" *ngIf="locked">

    <h1 class="mb-3">Desbloquear curso</h1>

    <p>¿Estás segur&#64; de que deseas desbloquear el curso?</p>

    <div id="status" class="mb-3">
        <div id="course-unlocking" *ngIf="unlocking">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="course-unlock-success" class="text-success" *ngIf="unlockSuccess">
            <i class="fas fa-check"></i>
            <span>Terminado. Ahora se recargará la página.</span>
        </div>
        <div id="course-unlock-error" class="text-danger" *ngIf="unlockError">
            <i class="fas fa-times"></i>
            <span>Error</span>
        </div>
    </div>

    <div id="buttons">
        <button class="btn btn-success me-3" (click)="unlock()">
            <i class="fa fa-lock"></i>
            <span>Continuar</span>
        </button>
        <button class="btn btn-danger me-3" (click)="close()">
            <i class="class fa fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

</div>